const TYPOGRAPHY_CLASSES = {
  en: {
    hero: 'typo-hero',
    h1: 'typo-h1',
    h2: 'typo-h2',
    h3: 'typo-h3',
    h4: 'typo-h4',
    h5: 'typo-h5',
    h6: 'typo-h6',
    h7: 'typo-h7',
    title1: 'typo-title1',
    title2: 'typo-title2',
    title3: 'typo-title3',
    b20Strong: 'typo-b20Strong',
    b18Strong: 'typo-b18Strong',
    b18: 'typo-b18',
    b16Strong: 'typo-b16Strong',
    b16: 'typo-b16',
    b14Strong: 'typo-b14Strong',
    b14: 'typo-b14',
    b13Strong: 'typo-b13Strong',
    b13: 'typo-b13',
    b12Strong: 'typo-b12Strong',
    b12: 'typo-b12',
    b11Strong: 'typo-b11Strong',
    b11: 'typo-b11',
  },
  kr: {
    h1: 'typo-krH1',
    h2: 'typo-krH2',
    h3: 'typo-krH3',
    h4: 'typo-krH4',
    h5: 'typo-krH5',
    h6: 'typo-krH6',
    h7: 'typo-krH7',
    title1: 'typo-krTitle1',
    title2: 'typo-krTitle2',
    title3: 'typo-krTitle3',
    defaultStrong: 'typo-krDefaultStrong',
    default: 'typo-krDefault',
    smallStrong: 'typo-krSmallStrong',
    small: 'typo-krSmall',
    b18Strong: 'typo-krB18Strong',
    b14Strong: 'typo-krB14Strong',
    b13Strong: 'typo-krB13Strong',
    b12Strong: 'typo-krB12Strong',
    b11Strong: 'typo-krB11Strong',
    b11: 'typo-krB11',
    caption: 'typo-krCaption',
  },
};

const DEFAULT_CLASS = {
  en: 'text-16 leading-en-body-high font-regular',
  kr: 'text-16 leading-kr-body font-regular',
};

const isKoreanText = (text = '') => /[ㄱ-ㅎㅏ-ㅣ가-힣]/.test(text);

/**
 * Tailwind typography 클래스 반환
 * @param {string} typoKey - theme.typography.style 키
 * @param {string} text - 내용(한글 감지용)
 * @param {"en" | "kr"} lang - 기본 언어, 기본값 'en'
 * @returns {string} Tailwind className
 */
export const getTypographyClass = (typoKey, text = '', lang = 'en') => {
  const appliedLang = isKoreanText(text) ? 'kr' : lang;
  return (
    TYPOGRAPHY_CLASSES[appliedLang]?.[typoKey] || DEFAULT_CLASS[appliedLang]
  );
};

export const applyTypography = (typoKey, text = '', lang = 'en') =>
  getTypographyClass(typoKey, text, lang);

/**
 * 모바일 → 특정 브레이크포인트 이상에서 타이포그래피를 전환한다.
 * @example applyResponsiveTypography('b14', 'b18') // "typo-b14 tabletV:typo-b18"
 * @param {string} mobileKey - 모바일(기본) 타이포 키
 * @param {string} upKey - breakpoint 이상에서 적용할 타이포 키
 * @param {string} text - 내용(한글 감지용)
 * @param {string} breakpoint - Tailwind breakpoint prefix, 기본값 'tabletV'
 * @param {"en" | "kr"} lang
 * @returns {string} Tailwind className
 */
export const applyResponsiveTypography = (
  mobileKey,
  upKey,
  text = '',
  breakpoint = 'tabletV',
  lang = 'en',
) => {
  const mobileClass = getTypographyClass(mobileKey, text, lang);
  const upClass = getTypographyClass(upKey, text, lang)
    .split(' ')
    .filter(Boolean)
    .map((cls) => `${breakpoint}:${cls}`)
    .join(' ');
  return `${mobileClass} ${upClass}`;
};

export default getTypographyClass;
